module.exports = __webpack_public_path__ + "img/sort_blue_24dp.55d75dbf.svg";